import React, { useMemo } from "react";
import styled from "styled-components";

const hueFromString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
};

const Tile = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${({ $minHeight }) => $minHeight || "180px"};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: ${({ $from, $to }) => `linear-gradient(135deg, ${$from} 0%, ${$to} 100%)`};
`;

const Grid = styled.div`
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.09) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.09) 1px, transparent 1px);
  background-size: 26px 26px;
  mask-image: radial-gradient(circle at 72% 28%, black, transparent 72%);
  -webkit-mask-image: radial-gradient(circle at 72% 28%, black, transparent 72%);
`;

const Glow = styled.div`
  position: absolute;
  width: 60%;
  height: 60%;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  filter: blur(48px);
  top: -12%;
  right: -12%;
`;

const Mono = styled.span`
  position: relative;
  z-index: 1;
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: ${({ $size }) => $size || "clamp(2.4rem, 5vw, 4rem)"};
  color: rgba(255, 255, 255, 0.94);
  letter-spacing: -0.02em;
`;

const initialsFrom = (label) =>
  (label || "")
    .replace(/[—–-].*$/, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

const MonogramTile = ({ label, seed, minHeight, fontSize, className }) => {
  const hue = useMemo(() => hueFromString(seed || label || "x"), [seed, label]);
  const from = `hsl(${hue}, 68%, 40%)`;
  const to = `hsl(${(hue + 55) % 360}, 72%, 32%)`;

  return (
    <Tile $from={from} $to={to} $minHeight={minHeight} className={className}>
      <Grid />
      <Glow />
      <Mono $size={fontSize}>{initialsFrom(label)}</Mono>
    </Tile>
  );
};

export default MonogramTile;
